import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';


const edit = {
	EditDat: null as Date | null,
	EditPracId: null as number | null,
	FakturaceprofilId: null as number | null,
	HodSzbNahr: null as number | null,
	HodSzbNahr1: null as number | null,
	HodSzbNahr2: null as number | null,
	HodSzbNahr8: null as number | null,
	Tablpozice: null as string | null,
	TablpoziceText: null as string | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { VyrobekvozOzn: [] },
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.NAHRADNI_SAZBA_TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.edit.Tablpozice = data.value;
			state.edit.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
